import {
  Button,
  PageHeader,
  SettingsList,
  Stack,
  Text,
} from '@relay-towing/ui';
import { ArrowUpRight } from 'lucide-react';
import { useMember } from '../../hooks/useMember';
import { operationsFor } from '../../lib/driverAppTabs';
import { links } from '../../lib/links';
import { openExternal } from '../../lib/nativeBridge';
import { TabItemRows } from '../shell/TabItemRows';
import { TabScreen } from '../shell/TabScreen';

/** "reports, team members and roles": the items, as a sentence lists them. */
const listed = (labels: string[]) => {
  const words = labels.map(
    (label) => label.charAt(0).toLowerCase() + label.slice(1)
  );
  return words.length > 1
    ? `${words.slice(0, -1).join(', ')} and ${words.at(-1)}`
    : (words[0] ?? '');
};

/**
 * The Operations tab: running the business, each item by its key. Drivers
 * opens here. The rest are run on the dashboard, so they are one button to
 * it, with a sentence saying what this role can do there, for someone new
 * to learn where things are. Each was a row of its own, every one of them
 * leaving for the same dashboard.
 */
export function OperationsScreen() {
  const member = useMember();
  const items = operationsFor(member);
  const inApp = items.filter((item) => 'screen' in item.opens);
  const onDashboard = items.filter((item) => 'dashboard' in item.opens);
  return (
    <TabScreen>
      <PageHeader title="Operations" layout="row" />
      <Stack gap={6}>
        {inApp.length ? (
          <SettingsList>
            <TabItemRows items={inApp} />
          </SettingsList>
        ) : null}
        {onDashboard.length ? (
          <Stack gap={4}>
            <Text tone="muted">
              {`On the dashboard you can manage ${listed(
                onDashboard.map((item) => item.label)
              )}.`}
            </Text>
            <Button
              variant="secondary"
              size="xl"
              pill
              fullWidth
              trailingIcon={<ArrowUpRight />}
              onClick={() => openExternal(links.dashboard)}
            >
              Open the dashboard
            </Button>
          </Stack>
        ) : null}
      </Stack>
    </TabScreen>
  );
}
